import { useEmployeeAvailabilityApi } from 'infrastructure/api';
import { ListResponse } from 'framework/list';
import { AvailabilityUserResponse, AvailabilityUserStatus } from '../../types';

const useAvailabilityUserApiService = () => {
  const { sendGetRequest, sendPostRequest } = useEmployeeAvailabilityApi();

  const getAvailabilityUserById = async (employeeId: string): Promise<AvailabilityUserStatus> => {
    const response = await sendGetRequest(`/employee-availability/statuses/${employeeId}`);
    return response.json();
  };

  const searchAvailabilityUsers = async (query: string): Promise<ListResponse<AvailabilityUserStatus>> => {
    const response = await sendPostRequest('/employee-availability/statuses/search', {
      pageNumber: 0,
      pageSize: 10,
      filter: {
        employeeName: {
          ct: query,
        },
      },
    });

    return response.json();
  };

  const checkRecipientAvailability = async (queryEmail: string): Promise<AvailabilityUserResponse> => {
    const response = await sendGetRequest(`/availability/${encodeURIComponent(queryEmail)}`);
    return response.json();
  };

  return {
    checkRecipientAvailability,
    getAvailabilityUserById,
    searchAvailabilityUsers,
  };
};

export default useAvailabilityUserApiService;
